<template>
  <div style="height: 40px ; text-align: left">
    <v-select
      :items="items"
      @change="setModelData"
      background-color="#ffffff"
      outlined
      :value="model"
      style="border-radius: 30px; text-align: left!important;"
      dense
    ></v-select>
  </div>
</template>

<script>
export default {
  name: "selectOption",
  props: {
    items: Array,
    model: ""
  },
  methods: {
    setModelData(val) {
      this.$emit("update", val);
    }
  }
};
</script>

<style scoped></style>
